import { LabelSharp } from "@material-ui/icons";
import React from "react";

export const DesktopTitles = ({ labels }) => {
  return (
    <div className="desktop-titles ">
      <h3 className="what-to-calc" tabIndex="0">{labels.title}</h3>
      <p className="press-score-and-fill" tabIndex="0">{labels.subtitle}</p>
    </div>
  )
}